/**
 * Sticky nav — toggles `is-scrolled` class once user scrolls past the threshold.
 */
export function initStickyNav() {
  const nav = document.getElementById('nav');
  if (!nav) return;

  function update() {
    nav.classList.toggle('is-scrolled', window.scrollY > 6);
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
}
